import React, { useState, useEffect, createRef, useRef } from 'react'
import Arrow from '../../../assets/images/arrow.png';
import { useTranslation } from 'react-i18next';
import { useSelector, connect, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { addLineBreaks, displayErrorMessage, LineBreaksSpan, retrieveData } from '../../../utils';
import logFirebaseEvents from '../../../components/LogFirebaseEvents';
import { GetApiHeadersWithBearer, GetApiHeadersWithOutBearer, PostRequest } from '../../../network/NetworkUtils';
import { UPGRADE_TO_KDUZU_PLUS, STATUS_SUCCESS_CODE, PAID_PROMO_KEY, TRAIL_PROMO_KEY } from '../../../network/URLConstants';

import { useKeyDown } from '../../../hooks/useKeyDown';
import CustomCarousel from '../../helpers/customCarousel';
import CustomModalPlus from '../../helpers/customModalPlus';
import RegisterSuccessModal from '../../../components/OnBoard/Signup/RegisterSuccessModal';
import ElectronicModal from '../../../components/OnBoard/Signup/ElectronicModal';
import BancorpPrivacyPolicy from '../../../components/OnBoard/Signup/BancorpPrivacyPolicy';
import UserAgreement from '../../../components/OnBoard/Signup/UserAgreement';
import SavingsAgreement from '../../../components/OnBoard/Signup/SavingsAgreement';
import DepositAgreement from '../../../components/OnBoard/Signup/DepositAgreement';
import ElectronicAgreement from '../../../components/OnBoard/Signup/ElectronicAgreement';
import CustomAlertModel from '../../../components/CustomComponents/CustomAlertModel';
import Loader from '../../../components/CustomComponents/Loader';
import Card from '../../../components/CustomComponents/Card';
import Modal from '../../../components/CustomComponents/Modal';
import HomeLayout from '../../../components/Layout/HomeLayout';
import HomeHeader from '../../../components/CustomComponents/HomeHeader';
import Layout from '../../../components/Layout';
import Oops from '../../../assets/images/Oops.png';
import { getUserMembership, showPrompt } from '../../../helpers/utils/Utils';
import Cookies from 'js-cookie';
import AddMoneyPopover from '../../../components/Home/AddMoneyPopover';
import KudzuPlusExitModal from '../../../components/Home/KudzuPlusExitModal';
import { CHECKING_CARD_CODE } from '../../../helpers/utils/Utils';
import CustomCarouselAdaptive from '../../helpers/CustomCarouselAdaptive';
import UpgradeSuccessModal from './UpgradeSuccessModal';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


export const KudzuPlusTermsandCondition = ({ finalRegistrationClick, openPersonalInfoSummaryClick, getDataFromPersonalInfo }) => {

    const providerIdentifier = useSelector(state => state.providerIdentifier);
    const personalInfo = useSelector(state => state.signUpPersonelInfo);
    const fromExtendFlowData = useSelector(state => state.fromExtendFlow);
    const button1Ref = useRef(null);
    const provider = useSelector(state => state.provider);
    const { t } = useTranslation();
    const location = useLocation();
    const fromSignup = location.state?.fromSignup; // Check if coming from signup flow
    const [isElectronicVerifyModalOpen, setIsElectronicVerifyModalOpen] = useState(false);
    const [isRegisterSucessModalOpen, setRegisterSucessModalModalOpen] = useState(false);
    const [showPolicys, setShowPolicys] = useState('terms');
    const [checkedValues, setCheckedValues] = useState([]);
    const dispatch = useDispatch();
    const userId = useSelector(state => state.userId);
    const deviceId = useSelector(state => state.deviceId);
    const [errorMessage, setErrorMessage] = useState('');
    const SubTittleStylesModal = "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)]";
    const [isLoading, setIsLoading] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-heading-clr)] lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[18px] md:text-[16px] sm:text-[15px] text-[17px] font-[400] cursor-pointer pointer-events-none mt-[10px]";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer pointer-events-none";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [quickActions, setQuickActions] = useState(true)
    const SelectedCardDetails = useSelector(state => state.selectedCardDetails);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [isEnroll, setIsEnroll] = useState(false)
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const [carousel, setCarousel] = useState('');
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(true);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [allButtonsDisable, setAllButtonsDisable] = useState(false);
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [checkBoxValue, setCheckBoxValue] = useState([]);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [message, setMessage] = useState('');
    const cards = useSelector(state => JSON.parse(state.userCards));
    const navigate = useNavigate()
    const [gradientButton, setGradientButton] = useState(false);
    const [gradientButtonBackground, setGradientButtonBackground] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [successMsg , setSuccessMsg] = useState(false)

    const [showAddMoneyModal, setShowAddMoneyModal] = useState(false)
    const [showKudzuPlusExitModal, setKudzuPlusExitModal] = useState(false)



    const closeAddMoneyPopOver = () => {
        setShowAddMoneyModal(false);
        setKudzuPlusExitModal(true);
    };

    const closeAndRedirectToHome = () => {
        navigate("/home");
    }

    const redirectToAddMoney = () => {
        navigate("/AccountServices/Spending/TransferMoney")
    };



    const closeKudzuPlusExitModal = () => {
        setKudzuPlusExitModal(false);
        navigate("/home")
    };

    const redirectToKudzuPlusExitModal = () => {
        setKudzuPlusExitModal(false);
        setShowAddMoneyModal(true);
    };
  

    const HeadingStyles =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[#ffffff]";
    const SubHeadingStyles =
        "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";

    // const deviceId = useSelector(state => state.deviceId); 
    const [acceptAll, setAcceptAll] = useState(false);
    const [checkboxesState, setCheckboxesState] = useState({
        privacy_user: false,
        deposit_savings: false,
        electronic_aggrement: false,
        savings_account_aggrement: false,
        penalty_perjury: false
        // paperless_statement: false
        // Add more checkboxes as needed
    });

    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const [promoKey,setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const checkboxes = useSelector(state => state.signupTermsAndConditionCheckbox);
    const userMembershipData = getUserMembership(loggedResponse);

    useDocumentTitle(t('page_title_kudzu_plus_terms'));

    const handleDepositTermsClick = () =>{
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
          return;
      }
      else {
          navigate('/Documents/Policies/Demand%20Deposit%20Account%20Agreement', { state: { name: 'Demand Deposit Account Agreement',
            url:
            "KudzuPlusDepositTerms"
             , accType: 64, CardKey: cards?.[0]?.CardKey } });
      }
   }

   const handleBankCorpPlocyClick = () =>{
    if (accessTokenToApi == undefined || accessTokenToApi == null) {
      return;
    }
     else {
      navigate('/Documents/Policies/Bancorp%20Privacy%20Notice', { state: { name: 'Privacy Policy',
        url:
        "PrivacyPolicyV2"
         , accType: 64, CardKey: cards?.[0]?.CardKey } });
    }
   }

   const handleElectronicCommunicationClick = () =>{
    if (accessTokenToApi == undefined || accessTokenToApi == null) {
      return;
    }
     else {
      navigate('/Documents/Policies/Electronic%20Communications%20Disclosure%20and%20Agreement', { state: { name: 'E-Sign Agreement',
        url:
        "ESign"
         , accType: 64, CardKey: cards?.[0]?.CardKey } });
    }
   }

    const slidesData = [
        {
            heading: (promoKey == PAID_PROMO_KEY || promoKey ==  TRAIL_PROMO_KEY) ? <p>{t('welcm_to_kudzu')}<span className='text-[#30BC89]'>+</span></p> :  <p>{t("welcm_to_kudzu")}</p>,
            paragraph: t("You_new_membership_comes_with_additional_Kudzu+"),
            imageUrl: require('../../../assets/kudzu-plus-images/kudzu-carousals.png'),
            dynamicHeaderStyles:"font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal md:h-[92px]",
            slackListHeight:"550px",
        },
        {
            heading: t("Go_Pro_with_Dark_Mode"),
            paragraph: t("Enjoy_your_new_nightshade_app_theme"),
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/Go_Pro_Mobile_Image.png'),
            dynamicHeaderStyles:"font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal md:h-[92px]",
            //slackListHeight:"auto"
           
        },
        
        {
            heading: t("Stay_Protected_with_Covered_by_Kudzu+"),
            paragraph: <p >{t("We’ve_got_you_covered_up_to_$100_updated")} <span className='text-[#94C3E8] cursor-pointer'>{t("here")}</span> </p>,
            // footerText: (
            //           <>
            //             <p>
            //               {(() => {
            //                 const text = t("enabled_overdraft_updated_footer");
            //                 const lines = text.split("\n");
            //                 const lastLine = lines.pop(); // Remove the last line to handle separately
            //                 const remainingText = lines.join("\n"); // Join the remaining lines back with \n
                    
            //                 return (
            //                   <>
            //                     {addLineBreaks(remainingText)}
            //                     {lastLine}{" "}
            //                     <span className="underline cursor-pointer"  
            //                      onClick={()=>navigate("/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions",{ state: { name: 'Covered by Kudzu Terms and Conditions', 
            //                         url:
            //                         (promoKey == PAID_PROMO_KEY || promoKey ==  TRAIL_PROMO_KEY)
            //                         ? "CoveredByKudzuPlusTerms"
            //                         : "CoveredByKudzuTerms",
            //                      accType: 64, CardKey: cards?.[0]?.CardKey } })}>
            //                       {t("kudzu_navigate_link")}
            //                     </span>
            //                   </>
            //                 );
            //               })()}
            //             </p>
            //           </>
            //         ),
            footerText:<p>{t("enabled_overdraft_updated_footer")}
            <span className="underline cursor-pointer"  
                               onClick={()=>navigate("/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions",{ state: { name: 'Covered by Kudzu Terms and Conditions', 
                                    url:
                                    (promoKey == PAID_PROMO_KEY || promoKey ==  TRAIL_PROMO_KEY)
                                    ? "CoveredByKudzuPlusTerms"
                                    : "CoveredByKudzuTerms",
                                 accType: 64, CardKey: cards?.[0]?.CardKey } })}>
                                  {t("kudzu_navigate_link")}
                                </span></p>,
            imageUrl: require('../../../assets/kudzu-plus-images/overdraft_imag.png'),
            dynamicHeaderStyles:"font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal md:h-[92px]",
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]",
            //slackListHeight:"auto"
        },
        {
            heading: t("Set_Intentions_with_Savings _Goals"),
            paragraph: <p className=''>{t("Customizable_Automatic_text")}</p>,
            footerText:<p>{t("APY_DISCLOSURE")}</p>,
            videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
            dynamicHeaderStyles:"font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal md:h-[92px]",
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]",
            //slackListHeight:"auto"
         },
        {
            heading: t("And_Even_Mor_Kudzu+_Perks"),
            paragraph: <p className='sm:w-[450px] lg:text-[16px] mb-8'> {t("Unlock_a_higher_interest_savings_APY_Updated")}</p>,
            dynamicHeaderStyles:"font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal md:h-[92px]",
             dynamicfooterStyles: "font-hanken-grotesk  modal-title  text-[#94C3E8] text-[12px] font-[400]",
            footerText:<div className='flex flex-col gap-4'>
                <p className='!w-[433px] !text-[11px]'>{t("even_perks_welcome_carousel_paraOne")}</p>
                <p className='!text-[11px]'>{t("even_perks_welcome_carousel_paraTwo")}</p>
                <p className='!text-[11px] !w-[435px]'>{t("even_perks_welcome_carousel_paraThree")}</p>
            </div>,
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
            getstartTrue: true,
            //slackListHeight:"auto"
        },
    ];


    const trueCount = Object.values(checkboxes).reduce((acc, curr) => (curr === true ? acc + 1 : acc), 0);
    useEffect(() => {
    }, [trueCount, checkboxes])

    useEffect(() => {
        const allChecked = Object.values(checkboxes).every((value) => value);
        setAcceptAll(allChecked);
    }, [checkboxes]);

    const handleAcceptAllChange = (event) => {
        debugger;
        // alert('accept all');
        const isChecked = event.target.checked;
        setAcceptAll(isChecked);

        // Update the state of each checkbox
        // setCheckboxes((prevCheckboxes) => {
        //   const updatedCheckboxes = { ...prevCheckboxes };
        //   for (const checkboxKey in updatedCheckboxes) {
        //     if (Object.prototype.hasOwnProperty.call(updatedCheckboxes, checkboxKey)) {
        //       updatedCheckboxes[checkboxKey] = isChecked;
        //     }
        //   }
        //   return updatedCheckboxes;
        // });
    };

    useEffect(() => {
        if ((checkboxes.savings_account_aggrement && trueCount >= 4) || (!checkboxes.savings_account_aggrement && trueCount >= 3)) {
            button1Ref.current.focus();
        }
    }, [trueCount, checkboxes])


    const handleCheckboxChange = (event, checkboxKey) => {
        const isChecked = event.target.checked;
        dispatch({
            type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
            payload: { 'key': checkboxKey, 'value': isChecked }
        })

    }

    const handleCheckboxKeyDown = (keyArray) => {
        debugger;
        setCheckBoxValue(keyArray)
        let updatedKeyObj = {}
        keyArray.forEach((key) => {
            updatedKeyObj[key] = !checkboxesState[key]
            dispatch({
                type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
                payload: { 'key': key, 'value': !checkboxesState[key] }
            })
        }
        )

        const updateObj = { ...checkboxesState, ...updatedKeyObj }
        setCheckboxesState(updateObj)

    }


    const handleClick = (type) => {
        setShowPolicys((prevState) => {
            if (type === 'privacy') {
                logFirebaseEvents("Terms_and_conditions", "bancorp’s_privacy_notice_clicked", "bancorp’s_privacy_notice_clicked", "", "");
                return 'privacy';
            } else if (type === 'agreement') {
                return 'agreement';
            } else if (type === 'deposit') {
                logFirebaseEvents("Terms_and_conditions", "deposit_account_agreement", "deposit_account_agreement", "", "");
                return 'deposit';
            } else if (type === 'savings') {
                return 'savings';
            } else if (type === 'electronic') {
                logFirebaseEvents("Terms_and_conditions", "electronic_communications_agreement_clicked", "electronic_communications_agreement_clicked", "", "");
                return 'electronic';
            } else {
                return 'terms';
            }
        });

    };
    const slidesDataForFeatureCarousel = [
        {
            heading: t("welcm_to_kudzu+"),
            paragraph: t("new_wel_extend_para"),
            imageUrl: require('../../../assets/kudzu-plus-images/K-plus-logo-new.png'),
            slackListHeight:"550px",
        },
        {
            heading: t("Go_Pro_with_Dark_Mode"),
            paragraph: t("Enjoy_your_new_nightshade_app_theme"),
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/Go-Pro-with-Dark-Mode.png')
        },
        {
            heading: t("Stay_Protected_with_Covered_by_Kudzu+"),
            paragraph: <p>{t("We’ve_got_you_covered_up_to_$100")} <span className='text-[#94C3E8] cursor-pointer'>{t("here")}</span> </p>,
            imageUrl: require('../../../assets/kudzu-plus-images/overdraft_imag.png'),
            footerText: t("covered_by_kudzu_wel_footer"),
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]",
        },
        {
            heading: t("Set_Intentions_with_Savings _Goals"),
            paragraph: t("Customizable_Automatic_text"),
            videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
            footerText:t("annual_footer"),
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]",
        },
        {
            heading: t("And_Even_Mor_Kudzu+_Perks"),
            paragraph: t("new_wel_even_more_perks_para"),
            dynamicSubHeaderStyles:"sm:w-[447px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]",
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
            footerText:<div className='flex flex-col gap-4'>
                            <p className='!w-[433px] !text-[11px]'>{t("even_perks_welcome_carousel_paraOne")}</p>
                            <p className='!text-[11px]'>{t("even_perks_welcome_carousel_paraTwo")}</p>
                            <p className='!text-[11px] !w-[435px]'>{t("even_perks_welcome_carousel_paraThree")}</p>
                        </div>,
             dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]",
            getstartTrue: true
        },
    ];


    const OnClickElectronicPapperless = (value) => {
        const updatedCheckboxes = { ...checkboxes, electronic_aggrement: value };
        // setCheckboxes(updatedCheckboxes);
        dispatch({
            type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
            payload: { 'key': 'electronic_aggrement', 'value': value }
        })



        const allChecked = Object.values(checkboxes).every((value) => value);
        // alert("allchecked"+ allChecked);
        setAcceptAll(allChecked);
        closeMobileVerificationModal();
    };


    const handleContinueClick = async () => {

        const checkedValues = Object.entries(checkboxes).map(([checkboxKey, checked]) => ({
            checkboxKey,
            checked,
        }));

        const privacyAggrement = checkedValues.find(
            (checkbox) => checkbox.checkboxKey === 'privacy_user'
        );

        const depositAgreement = checkedValues.find(
            (checkbox) => checkbox.checkboxKey === 'deposit_savings'
        );

        const electronicAgreement = checkedValues.find(
            (checkbox) => checkbox.checkboxKey === 'electronic_aggrement'
        );

        const paperLessAgreement = checkedValues.find(
            (checkbox) => checkbox.checkboxKey === 'paperless_statement'
        );
        const savingsAccountAggrement = checkedValues.find(
            (checkbox) => checkbox.checkboxKey === 'savings_account_aggrement'
        );

        dispatch({ type: "SIGN_UP_TERMS_AND_CONDITIONS", payload: { signUpTermsAndConditions: checkboxes } });
        const deviceId = await retrieveData('updatedDeviceId');
        let headers = await GetApiHeadersWithOutBearer(deviceId);
        const requestObj = {
            "applicationId": personalInfo?.applicationId,
            "language": "en",
            "username": personalInfo?.username,
            "firstName": personalInfo?.firstName,
            "lastName": personalInfo?.lastName,
            "preferredName": personalInfo?.preferredName,
            "middleInitial": "",
            "ssn": personalInfo?.ssn,
            "dateOfBirth": personalInfo?.dateOfBirth,
            "line1": personalInfo?.line1,
            "line2": personalInfo?.line2,
            "city": personalInfo?.city,
            "state": personalInfo?.state,
            "zipCode": personalInfo?.zipCode,
            "isEsignAccepted": electronicAgreement.checked,
            "IsPrivacyPolicyAccepted": privacyAggrement.checked,
            "IsCHAgreementAccepted": true,
            "CreateSavings": checkboxes.savings_account_aggrement
        };
        if (personalInfo?.password !== undefined && personalInfo?.password !== '') {
            requestObj.password = personalInfo?.password;
        }

        if (providerIdentifier != null && providerIdentifier != undefined) {
            requestObj.provider = provider;
            requestObj.providerId = providerIdentifier;
        }
        requestObj.formattedAddress = personalInfo?.formattedAddress;

        if (global.inviteCode != null && global.inviteCode != undefined) {
            requestObj.inviteCode = global.inviteCode
        }
        dispatch({ type: 'SIGN_UP_PERSONEL_INFO', payload: { signUpPersonelInfo: requestObj } });
        getDataFromPersonalInfo(requestObj);
        // openPersonalInfoSummaryClick();
        finalRegistrationClick()
        return;

    }

    useKeyDown(() => {
        const trueCount = Object.values(checkboxes).reduce((acc, curr) => (curr === true ? acc + 1 : acc), 0);
        if (!(button1Ref.current)) {
            if ((checkboxes.savings_account_aggrement && trueCount >= 4) || (!checkboxes.savings_account_aggrement && trueCount >= 3)) {
                if (!checkboxes.savings_account_aggrement) { showAlertModal(true, t(""), t("great_would_u_like_two_enroll"), t('set_aside_money_for_the_things_that_matter'), true, true, t('enroll_savings_account'), t('maybe_later'), true, require('../../../assets/images/illo_beneficiary_4x.png'), false, true) }
                else {
                    handleContinueClick();
                }
            }
        }
    }, ["Enter"]);




    const OpenElectricVerificationModal = () => {
        setIsElectronicVerifyModalOpen(true);

    };

    const closeMobileVerificationModal = () => {
        setIsElectronicVerifyModalOpen(false);
    };

    const openRegisterSuccessModalOpen = () => {
        setRegisterSucessModalModalOpen(true);

    };

    const closeRegisterSuccessModal = () => {
        setRegisterSucessModalModalOpen(false);
    };

    const onCancelBtnClick = () => {
        if (btn2Text == t('maybe_later')) {
            closeModel()
            handleContinueClick()
            logFirebaseEvents("Enroll_Savings_Account", "Maybe_later_Clicked", "Maybe_later_Clicked", "", "");
        }

    }


    const onAcptBtnClick = () => {
        if (btn1Text == t('enroll_savings_account')) {
            setIsEnroll(true); closeModel();
            logFirebaseEvents("Enroll_Savings_Account", "Enroll_Savings_Account_Clicked", "Enroll_Savings_Account_Clicked", "");
        }
    }

    useEffect(() => { }, [isEnroll])
    const closeModel = () => {
        setShowModel(false);
    }
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }
    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, allButtonsDisable,gradientButton,largeImage,gradientButtonBackground) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setAllButtonsDisable(allButtonsDisable)
        setGradientButton(gradientButton)
        setLargeImage(largeImage)
        setGradientButtonBackground(gradientButtonBackground)
    }
    useEffect(() => {
      return () => {
        const extendData = { fromExtendFlow: false };
        dispatch({ type: 'FROM_EXTEND_FLOW', payload: extendData });
        setCheckBoxValue({
            privacy_user: false,
            deposit_savings: false,
            electronic_aggrement: false,
            savings_account_aggrement: false,
            penalty_perjury: false
        })
        checkBoxValue.forEach((key) => {
            debugger;
            dispatch({
                type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
                payload: { key: key, value: false }  
            });
        });
        dispatch({
            type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
            payload: { 'key': 'electronic_aggrement', 'value': false }
        })
        dispatch({
            type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
            payload: { 'key': 'privacy_user', 'value': false }
        })
      }
    }, []) 
    
// const handleWelcomeCarousel = () =>{
//     debugger;
//     if(fromExtendFlowData){
//         // showAlertModalPlus(true, '',<><span className='text-[#94C3E8] cursor-auto '>{t("success")}</span> {t("Your_Kudzu+_membership_has_been_extended")}</>,t("Click_below_to_review_the_full_features_and_benefits"),true,true,t('view_features_benifits,true'),require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", "", true, "","",true, "", false, false, false, true,true, "");
//         showAlertModalPlus(
//             true,
//             '',
//             <><span className='text-[#94C3E8] cursor-auto '>{t("success")}</span> {t("Your_Kudzu+_membership_has_been_extended")}</>,
//             t("Click_below_to_review_the_full_features_and_benefits"),
//             true,
//             true,
//             t('view_features_benifits'),
//             t('home'),
//             true,
//             require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'),
//             '',
//             true,
//             "",
//             "",
//             false,
//             "",
//             false, // fullwidth 
//             false, //footer button value 
//             false, //All buttons disable
//             true,
//             true,
//             ""
//         );
//     }
//     else{
//         alert("uyfyu")
//     }
// }

const handleWelcomeCarousel = async () => {
         
    const deviceId = await retrieveData('updatedDeviceId')
    setIsLoading(true)
    let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    const requestObj = {
        sessionId: global.sessionId
    }
    
    // In signup flow, user has no cards yet - navigate back to complete registration
    if (!cards || cards.length === 0) {
        if (fromSignup) {
            setIsLoading(false);
            navigate('/onboard', { state: { acceptedTC: true } });
            return;
        }
        console.error('No cards available.');
        setIsLoading(false);
        return;
    }
    
    const checkingCard = cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE));
    if (!checkingCard) {
        console.error('No checking card found');
        setIsLoading(false);
        return;
    }
    
    const url = UPGRADE_TO_KDUZU_PLUS.replace('{cardKey=0}', checkingCard.CardKey);

    PostRequest(url, requestObj, headers).then((response) => {
        debugger;
        let parsedResponse = JSON.parse(response);

        if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
            const trailRemainingDays = parsedResponse.Response?.Subscription?.TrailRemainingDays;

            if(trailRemainingDays > 0)
            {
                setSuccessMsg(true)
            }else{
                setSuccessMsg(false)
            }
            checkBoxValue.forEach((key) => {
                debugger;
                dispatch({
                    type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
                    payload: { key: key, value: false }  // Remove quotes around key
                });
            });
            dispatch({
                type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
                payload: { 'key': 'electronic_aggrement', 'value': false }
            })
            dispatch({
                type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
                payload: { 'key': 'privacy_user', 'value': false }
            })
            setIsLoading(false);
            // const kudzuPlusTrueVal = { kudzuPlusTrue: true };
            // dispatch({ type: 'KUDZU_PLUS_TRUE', payload: kudzuPlusTrueVal });
            const data = parsedResponse?.Response
            console.log("responsed data is", data);
            const ShowUpgradePrompts = showPrompt(data);
            dispatch({ type: "LOGGED_IN_RESPONSE", payload: { loggedInResponse: JSON.stringify(parsedResponse.Response) } });

            dispatch({ type: "SHOW_PROMPT_TRUE", payload: { ShowPromptsTrue: ShowUpgradePrompts }, });

            const hasSubscription = parsedResponse?.Response?.Subscription && Object.keys(parsedResponse?.Response?.Subscription).length > 0
            const isKudzuPlusAccount = {
                kudzuPlusTrue: hasSubscription === true ? true : false
            };
            dispatch({ type: 'KUDZU_PLUS_TRUE', payload: isKudzuPlusAccount });
            if (isKudzuPlusAccount.kudzuPlusTrue) {
                const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
                Cookies.set(kudzuPlusSetForCookies, true, { expires: 1825 });
            }
            else {
                const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
                Cookies.remove(kudzuPlusSetForCookies);
            }
            if(fromExtendFlowData){
                const expiredFlowCookieRemove = `expiredFlow${cards[0].ExternalSVAID}`;
                Cookies.remove(expiredFlowCookieRemove);
                showAlertModalPlus(  true,'', <><span className='text-[#94C3E8] cursor-auto '>{t("success")}</span> {addLineBreaks(t("Your_Kudzu+_membership_has_been_extended"))}</>, t("Click_below_to_review_the_full_features_and_benefits"),true,  true,   t('view_features_benifits'), t('home'), true, require('./../../../assets/kudzu-plus-images/K-plus-logo.png'),'', true, "","",false,"",false,false,false,true, true,"");
            }
            else{
                // Show success modal after terms acceptance
                openRegisterSuccessModalOpen();
            }

           
        } else {
            setTimeout(() => {
                var arrMessages = parsedResponse.Messages;
                const targetMessage = arrMessages.find(msg => msg.MessageOrField === "KudzuPlusUpgradeInsufficientBalance");
        if (targetMessage) {
            // setMessage(targetMessage.DisplayText);
            setShowAddMoneyModal(true);
        } else {
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setMessage(displayText);
        }
                setIsLoading(false);
            }, 500);

        }
    })
}

    const onAcptBtnClickPlusModal = () => {
        if(btn1Text == t('view_features_benifits')){
            showAlertModalPlus(false)
            setIsLoading(true)
            setTimeout(() => {
                showAlertModalPlus(true, '', '', "", false, false, '', '', true, '', <CustomCarouselAdaptive slidesData={slidesDataForFeatureCarousel} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} finalButtontextChange={t('done')} dotsAbove={true} forClimbBtn={true} forClimbHomeBtn={true} />, true, "", "", true, "", false, false, false,false,true);
              setIsLoading(false)
            }, 1000);
        }
        else{
        navigate('/home')
        }

    }

    const onCancelBtnClickPlusModal = () => {
        navigate('/home')
    }

    const closeModePlus = () => {
        navigate('/home')
    }

    const closeSuccessModal =() =>{
       navigate('/home')
    }
  
   const onExploreFeturesClick =()=>{
           setRegisterSucessModalModalOpen(false)
           showAlertModalPlus(
                    true,
                    '',
                    '',
                    "",
                    true,
                    true,
                    promoKey == PAID_PROMO_KEY ? t('Join_Kudzu+') : t('Begin_Free_3-Month_Trial'),
                    t('No_Thanks'),
                    true,
                    '',
                    <CustomCarouselAdaptive slidesData={slidesData} dotsAbove={true} buttonsEnableForWelcome={true} />,
                    true,
                    "",
                    "",
                    false,
                    "",
                    false, // fullwidth
                    false, //footer button value
                    true, //All buttons disable
                    false,
                    false,
                    ""
                );
   }


    return (

        <HomeLayout  hideSidebar={true}>


            <CustomModalPlus isOpen={showPlusModal} onClose={closeModePlus}
                image={modelImage}
                carousel={carousel}
                comparisonScreen={comparisonScreen}
                summaryParagraph={summaryParagraph ? <p className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStyles}> {headerMsg}</p>}
                subHeaderMsg={subHeaderMsg ? <p className={SubHeaderMsgStyles}>{subHeaderMsg}</p> : ""}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                fullWidth={fullWidth}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                footerButtonEnable={footerButtonEnable}
                allButtonsDisable={allButtonsDisable}
                gradientButton={gradientButton}
                largeImage={largeImage}
                gradientBtnBackground={gradientButtonBackground}
            />

            <Modal
                isOpen={isElectronicVerifyModalOpen}
                onClose={closeMobileVerificationModal}
                isLogo={false}
                Fullheight={true}
                title={null}
                subtitle={null}
                content={<div><ElectronicModal handleElectronicClick={OnClickElectronicPapperless} /></div>}
            />

            {/* {open Sucess verify modal} */}

            {/* <Modal
                isOpen={isRegisterSucessModalOpen}
                onClose={closeRegisterSuccessModal}
                isLogo={false}
                subHeaderMsg={<p className="font-hanken-grotesk modal-title lg:text-[18px] 
        md:text-[17px] sm:text-[15px] text-[14px] font-normal cursor-pointer pointer-events-none">{t("standard_msg_and_data_rates_may_apply")}</p>}
                title={null}
                subtitle={null}
                content={<div><UpgradeSuccessModal  btnOne={""} btnTwo={""}/></div>}
            /> */}

              <Modal
                isOpen={isRegisterSucessModalOpen}
                onClose={closeSuccessModal}
                            alignItems={"items-center"}
                            isClimbg={false}
                            title={
                                <p className={`${HeadingStyles} hidden sm:flex`}>
                                    {t("Success!")}
                                </p>
                            }
                            subtitle={
                                <p>
                                    <span className={`${HeadingStyles} visible sm:hidden`}>
                                        {t("Success!")}
                                    </span>
                                    <span className={SubHeadingStyles}>
                                        {successMsg ? (
                                            <>Your Kudzu<span className="text-[#30BC89]">+</span> trial membership is now active.</>
                                        ) : (
                                            <>Your Kudzu<span className="text-[#30BC89]">+</span> membership is now active.</>
                                        )}
                                    </span>

                                </p>
                            }
                            content={
                                <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                                    <UpgradeSuccessModal ModalClose={closeSuccessModal} showMainText={false} btnOne={closeSuccessModal} btnTwo={onExploreFeturesClick}  showMainText={successMsg ? t('Trial_Success') : (t('Plus_Success'))}/>
                                </div>
                            }
                        />
            

            <>
                   <Modal
                    Fullheight={true}
                    isOpen={showAddMoneyModal}
                    onClose={closeAndRedirectToHome}
                    alignItems={"items-center"}
                    isKudzuPlusBg={true}
                    // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('removeSpednAlert')}</p>}
                    subtitle={
                        <p>
                            <span className={`${HeadingStyles}`}>
                                <span className='text-[#94C3E8]'>
                                    {t('Oops! ')}
                                </span>
                            </span>
                            <span className={`${HeadingStyles}`}>
                                {t("upgrade_could_not_be_completed")}
                            </span>
                        </p>
                    }
                    content={
                      <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <AddMoneyPopover
                          content1={t("Add_Money_Continue")}
                          btn1={t("Add Money")}
                          btn1Function={redirectToAddMoney}
                          btn2={t("Upgrade Later")}
                          btn2Function={closeAddMoneyPopOver}
                          icon={true}
                        />
                      </div>
                    }
                  />
                  </>

                  <>
                  <Modal
                  Fullheight={true}
                  isOpen={showKudzuPlusExitModal}
                  onClose={closeKudzuPlusExitModal}
                  alignItems={"items-center"}
                  isKudzuPlusBg={true}
                  subtitle={
                    <p>
                        <span className={`${HeadingStyles}`}>
                                <span className='text-[#94C3E8]'>
                                    {t('No worries!')}
                                </span>
                            </span>
                        <span className={`${HeadingStyles}`}>
                            {t("Kudzu_will_be")}
                        </span>
                    </p>
                  }
                  content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <KudzuPlusExitModal
                         content1={t("Explore_Kudzu_features")}
                         btn1={t("Back")}
                         btn1Function={redirectToKudzuPlusExitModal}
                         btn2={t("Home")}
                         btn2Function={closeKudzuPlusExitModal}
                         icon={true}
                        />

                    </div>
                  }
                  />
                  </>


            {showPolicys === 'terms' && (
                <Card
                    
                    footerBgDisabled={true}
                    heading={
                        <>
                            <span className={`md:contents sm:flex font-serif-pro  sm:text-[#94C3E8]  text-[var(--text-clr-secondary2)] lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[30px] leading-[31px] font-[400]`}>{isEnroll ? t('great_exclamation') : t('almost_there')}</span>
                        </>
                    }
                    subheading={<span className={` text-white font-[400] `} >{isEnroll ? t("terms_and_condition_saving_heading") : t('Review_Condition')}</span>}
                    Cardcaption={<p className='text-white' >{isEnroll ? LineBreaksSpan(t("terms_and_condition_saving_subheading")) : t('terms_and_conditions_card_heading')}</p>}
                    header={true} footer={false}
                    backgroundColor={'#262B3A'}
                    cardHeight={'auto'}
                    cardBg={'#262B3A'}
                    CardRadius={true}
                    footerClass={true}
                    footerContent={
                        <>
                            {
                                ((checkboxes.savings_account_aggrement && trueCount >= 4) || (!checkboxes.savings_account_aggrement && trueCount >= 3)) ? (
                                    <div className="flex flex-col justify-center items-center gap-4 w-full">
                                        <button
                                            ref={button1Ref}
                                            type="button"
                                            tabIndex={'0'}
                                            onClick={() => {
                                                // Always call handleWelcomeCarousel to enroll in Kudzu+ and show success modal
                                                handleWelcomeCarousel();
                                            }}
                                            className="focus:outline-none   w-[58%] font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[var(--spending-card-border-clr)] hover:bg-[var(--spending-card-border-clr)] focus:bg-[var(--spending-card-border-clr)] active:bg-[var(--spending-card-border-clr)] cursor-pointer flex justify-center items-center p-4"
                                            autoFocus
                                        >
                                            { promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true || userMembershipData?.extendTrial ?  t('Upgrade_Now'):t('Begin_Free_3-Month_Trial')}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                logFirebaseEvents("terms_and_condition", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
                                                if (fromSignup) {
                                                    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: { isSignUpKudzuplusTrue: false } });
                                                    navigate('/onboard', { state: { acceptedTC: true } });
                                                } else {
                                                    navigate(-3);
                                                }
                                            }}
                                            className="w-[58%] font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#94C3E8] cursor-pointer flex justify-center items-center p-4"
                                        >
                                            {t('no_thanks')}
                                        </button>
                                    </div>
                                ) :
                                    (
                                        <div className="flex flex-col justify-center items-center gap-8 w-full">
                                            <button
                                                type="button"
                                                className="focus:outline-none  w-[58%] font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#FFFFFF] bg-[var(--spending-card-border-clr)] hover:bg-[var(--spending-card-border-clr)] focus:bg-[var(--spending-card-border-clr)] active:bg-[var(--spending-card-border-clr)] cursor-pointer flex justify-center items-center p-4"
                                                // autoFocus
                                            >
                                                { promoKey == PAID_PROMO_KEY ||loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true ||userMembershipData?.extendTrial ? t('Upgrade_Now'):t('Begin_Free_3-Month_Trial')}
                                            </button>
                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    navigate(-3);
                                                    //  navigate('/home')
                                                }}
                                                className="w-[58%] font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#94C3E8] cursor-pointer flex justify-center items-center p-4"
                                            >
                                                {t('no_thanks')}
                                            </button>
                                        </div>)
                            }

                        </>
                    }
                >
                    <p className={`h-[43px] font-[300] text-white  md:text-[20px] sm:text-[12px] text-[16px] font-hanken-grotesk sm:mt-[10px] mt-[25px]`}>{t('accept_terms_signup')}</p>
                    <div className='mt-[4.5rem] md:w-[460px] sm:w-[301px] w-full'>
                        {!isEnroll &&
                            <div className="flex" >
                                <input
                                    id="privacy-user-checkbox"
                                    name="privacy-agreement"
                                    type="checkbox"
                                    className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms"
                                    value="privacy_user"
                                    checked={checkboxes.privacy_user}
                                    onKeyDown={(event) => {
                                        console.log("event----", event)
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            handleCheckboxKeyDown(['privacy_user', 'electronic_aggrement'])
                                        }
                                    }}
                                    autoFocus
                                    onChange={() => {
                                        handleCheckboxKeyDown(['privacy_user', 'electronic_aggrement'])

                                    }}
                                    tabIndex="0"
                                />
                                <label htmlFor="privacy-user-checkbox" className={`font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:text-sm sm:text-[12px]  text-[14px] md:font-[540] sm:font-medium font-normal text-white dark:text-gray-300`} >{t('read_and_agree')}
                                    <span
                                        tabIndex="0"
                                        className={`ml-1 text-[#94C3E8] font-bold cursor-pointer`}
                                        onClick={handleElectronicCommunicationClick}
                                    >{t('electronic_communications_agreement')}</span>{t('and')}
                                    <span
                                        className={`ml-1 text-[#94C3E8] cursor-pointer font-bold`}

                                        tabIndex="0" onClick={handleBankCorpPlocyClick}
                                    >{t('bancorp’s_privacy_notice')}</span>.

                                </label>
                            </div>
                        }

                        {!isEnroll &&
                            <div className="flex mb-4 mt-10">
                                <input
                                    id="deposit-savings-checkbox"
                                    name="deposit-agreement"
                                    type="checkbox"
                                    className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms"
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {

                                            event.preventDefault();
                                            handleCheckboxKeyDown(['deposit_savings'])
                                        }
                                    }}
                                    value="deposit_savings"
                                    checked={checkboxes.deposit_savings}
                                    onChange={(event) =>
                                        //  handleCheckboxChange(event, 'deposit_savings')
                                        handleCheckboxKeyDown(['deposit_savings'])

                                    }
                                    tabIndex="0"
                                />
                                <label htmlFor="deposit-savings-checkbox" className={`font-hanken-grotesk ml-4 sm:ml-2 md:ml-4  md:text-sm sm:text-[12px] text-[14px] md:font-[540] sm:font-medium font-[300] text-white   dark:text-gray-300 cu`}>
                                    <span tabIndex="0" className={`ml-1  text-[#94C3E8]  cursor-pointer font-bold`} onClick={handleDepositTermsClick}
                                    >{addLineBreaks(t('Kudzu+_DDA_Button'))}</span>
                                </label>
                            </div>
                        }


                        {isEnroll &&
                            <div className="flex mb-4 mt-16">
                                <input
                                    id="savings-account-checkbox"
                                    name="savings-agreement"
                                    type="checkbox"
                                    className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms"
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            handleCheckboxKeyDown(['savings_account_aggrement'])

                                        }
                                    }}
                                    value="savings_account_aggrement"
                                    checked={checkboxes.savings_account_aggrement}
                                    onChange={(event) =>
                                        // handleCheckboxChange(event, 'savings_account_aggrement')
                                        handleCheckboxKeyDown(['savings_account_aggrement'])
                                    }
                                    tabIndex="0"
                                    autoFocus
                                />
                                <label htmlFor="savings-account-checkbox" className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:font-[540]  md:text-sm sm:text-[12px] text-[14px]  sm:font-medium font-[300]  text-white dark:text-gray-300 cu">
                                    <span tabIndex="0" className=' ml-1 text-blue-500 cursor-pointer font-bold'
                                    >{t('savings_account_aggrement')}</span>.
                                </label>
                            </div>
                        }


                        {message && <div className="flex sm:mx-0 flex-row gap-4 justify-start mt-6 mb-2 ">
                            <img src={Oops} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
        sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                            <p className={`font-hanken-grotesk font-[500] text-[16px]  
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-white `}>
                                <span className="text-[#30BC89] font-[600]
        lg:font-[600]"> Oops! </span>{message}</p>
                        </div>}

                        <p className={`font-hanken-grotesk sm:font-[540] font-[300] md:text-[17px] sm:text-[12px] text-[14px]  text-white  dark:text-gray-300 pb-[15rem] pt-12`}>
                            {promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true ? t('by_tapping_join_kudzu_plus') : t('by_tapping_begin_three_month_trail')} </p>
                    </div>
                </Card>
            )
            }

            {
                showPolicys === 'privacy' && (
                    <BancorpPrivacyPolicy handleClick={handleClick} />
                )
            }
            {
                showPolicys === 'agreement' && (
                    <UserAgreement handleClick={handleClick} />
                )
            }
            {
                showPolicys === 'deposit' && (
                    <DepositAgreement handleClick={handleClick} />
                )
            }
            {
                showPolicys === 'savings' && (
                    <SavingsAgreement handleClick={handleClick} />
                )
            }
            {
                showPolicys === 'electronic' && (
                    <ElectronicAgreement handleClick={handleClick} />
                )
            }
            <CustomAlertModel
                isOpen={showModel}
                onClose={closeModel}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                // footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
                imageMargin={subHeaderMsg == t('set_aside_money_for_the_things_that_matter') ? 'my-10' : ''}
            />
            {isLoading && <Loader />}
        </HomeLayout >

    )
}

export default KudzuPlusTermsandCondition;